import { Dialog } from "@mui/material";

import { Customer } from "views/Customers/Customer/Customer";

import { EDIT_MODAL_STYLES } from "editConfig";

export function QuickAddCustomer(props) {
  const { open, onClose, initialNameValue, onAdd } = props;

  return (
    <Dialog open={open} onClose={onClose} {...EDIT_MODAL_STYLES}>
      <Customer
        key={open}
        name={initialNameValue}
        onAdd={onAdd}
        onClose={onClose}
        fromForm={true}
      />
    </Dialog>
  );
}
